import  { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import { ROUTES } from '@core/config/constants';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  const showFooter = location.pathname !== ROUTES.REELS;

  return (
    <div className="layout">
      <Header />
      <main className="layout__main">
        <div className="layout__content">{children}</div>
      </main>
      {showFooter && <Footer />}
    </div>
  );
};
